import "./InternalImageSliderSelector.scss"
import React, {useEffect, useState} from "react";
import FileManagerSelector from "../../../pages/fileManager2/selector/FileManagerSelector";
import {FileManagerTypes} from "../../../component/fileManager/FileManager";
import {changeContent, EditorItemType, prepareEditorItem} from "../RaikoCustomEditor2";
import Fancybox from "../../fancybox/Fancybox";
import thumbnail from "../image/Images-cuate.svg";
import {
    DialogSize,
    RaikoConfirmDialog,
    RaikoDefaultDialogPage, RaikoSectionContainer,
    showWarningMessage
} from "@moeindal/base-raiko-panel-components";

export default function InternalImageSliderSelector(
    {
        value = [],
        priority,
        editorValue,
        setEditorValue,
        bucketId = FileManagerTypes.PROJECT_IMAGES.id
    }) {

    const [items, setItems] = useState(value)

    function prepareSliderItem(url, id) {
        return {
            url,
            id: id
        };
    }

    /*useEffect(() => {

        if (typeof value !== 'undefined' && value.length > 0) {
            setItems(value)
            /!*value.map(async (item, index) => {
                const url = await new HttpClient()
                    .get(
                        `files/${item}/urls/public`
                    ).then(res => res.downloadUrl)

                setItems(prev => [
                    ...prev,
                    prepareSliderItem(url, item)
                ])
            })*!/
        } else
            setItems([])

    }, [value])*/

    const [galleryDialogOpenState, setGalleryDialogOpenState] = useState(false);

    function handleOpenFileManager() {
        setGalleryDialogOpenState(true)
    }

    function checkNotExistItem(url) {
        let exist = false
        items.map((item) => {
            if (item === url)
                exist = true
        })


        return !exist
    }

    function handleSelectImage(id, url) {
        if (checkNotExistItem(url)) {
            const _items = items
            _items.push(url)

            setItems(_items)

            /*const ids = []
            _items.map(item => {
                ids.push(item.id)
            })*/

            changeContent(
                editorValue,
                setEditorValue,
                prepareEditorItem(
                    _items
                    , EditorItemType.IMAGE_SLIDER),
                priority)
        } else {
            showWarningMessage("تصویر انتخابی از قبل انتخاب شده است.")
        }
    }

    const [confirmDialogOpenState, setConfirmDialogOpenState] = useState(false);
    const [selectedItemUrl, setSelectedItemUrl] = useState("");

    function handleDeleteItem() {
        const _items = []


        items.map((url, index) => {
            if (url !== selectedItemUrl) {
                _items.push(url)
            }
        })

        setItems(_items)

        changeContent(
            editorValue,
            setEditorValue,
            prepareEditorItem(
                _items
                , EditorItemType.IMAGE_SLIDER),
            priority)


        setConfirmDialogOpenState(false)
        setSelectedItemUrl("")
    }

    return (
        <>
            <RaikoDefaultDialogPage
                onClose={_ => {
                    setGalleryDialogOpenState(false)
                }}
                open={galleryDialogOpenState}
                dialogSize={DialogSize.LARGE}
                pageTitle={"تصویر مورد نظر خود را انتخاب نمایید."}
            >
                <FileManagerSelector
                    setOpenDialog={setGalleryDialogOpenState}
                    bucketId={bucketId}
                    setSelectedFileUrl={handleSelectImage}
                />

            </RaikoDefaultDialogPage>

            <RaikoConfirmDialog
                openConfirmDialog={confirmDialogOpenState}
                cancelAction={_ => setConfirmDialogOpenState(false)}
                doAction={handleDeleteItem}
                pageTitle={"حذف آیتم"}
                warningDescription={""}
            />

            <div className={"baseInternalImageSliderSelector"}>

                <RaikoSectionContainer
                    title={"اسلایـدر"}
                    subTitle={"تصویر های انتخاب شده در این قسمت به صورت اسلایدر در جزئیات مقاله به نمایش درخواهد آمد."}
                    actionButtonTitle={"افزودن تصویر"}
                    hasActionButton
                    actionButtonOnclick={handleOpenFileManager}
                >
                    {
                        items && items.length > 0 ?
                            <div className={"baseInternalImageSliderSelector"}>

                                <Fancybox
                                    options={{
                                        Carousel: {
                                            infinite: false,
                                        },
                                    }}
                                >

                                    {

                                        items.map((url, index) => {
                                            return <div className={"sliderImageItemsContainer"} key={index}>
                                                <img src={url} alt=""/>
                                                <div className={"sliderImageItemAccessContainer"}>

                                                    <a href={url} data-fancybox={"gallery"} data-caption={url}>
                                                        <div className={"zoom_icon iconContainer"}/>
                                                    </a>

                                                    <div className={"icTrash iconContainer"}
                                                         onClick={_ => {
                                                             setSelectedItemUrl(url)
                                                             setConfirmDialogOpenState(true)
                                                         }}/>

                                                </div>
                                            </div>
                                        })
                                    }

                                    <div
                                        className={"addNewImageCardContainer"}
                                        onClick={_ => {
                                            setGalleryDialogOpenState(true)
                                        }}>
                                        <span>تصویر جدید</span>
                                    </div>

                                </Fancybox>
                            </div>
                            :
                            <div
                                className={"notFoundItemsInSliderContainer"}
                                onClick={handleOpenFileManager}
                            >

                                <img src={thumbnail} alt=""/>
                                <span>برای انتخاب اولین تصویر اسلایدر کلیک نمایید.</span>
                            </div>
                    }
                </RaikoSectionContainer>
            </div>
        </>

    )
}
